export const RAF_QUESTIONS_REQUEST = 'RAF_QUESTIONS_REQUEST'
export const RAF_QUESTIONS_SUCCESS = 'RAF_QUESTIONS_SUCCESS'
export const RAF_QUESTIONS_FAILURE = 'RAF_QUESTIONS_FAILURE'
export const RAF_QUESTIONS_UPDATE = 'RAF_QUESTIONS_UPDATE'

